import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import type { EditionBenefitsRelayProps, VariantId } from '../../types';
import { getHamsKey } from '../../utils/getHamsKey';
import { getProjectType } from '../../utils/getProjectType';

import editionBenefitsModalRelayQueryParameters from './__generated__/editionBenefitsModalRelayQuery.graphql';
import type {
	EditionBenefitsModalRelayEntryPointProps,
	EditionBenefitsModalRelayEntryPointQueries,
} from './edition-benefits-modal-relay';

type EntryPointParams = Pick<EditionBenefitsRelayProps<VariantId>, 'cloudId' | 'product'>;

type EditionBenefitsModalEntryPointComponent = EntryPointComponent<
	EditionBenefitsModalRelayEntryPointQueries,
	EditionBenefitsModalRelayEntryPointProps['entryPoints'],
	EditionBenefitsModalRelayEntryPointProps['props'],
	EditionBenefitsModalRelayEntryPointProps['extraProps']
>;

export const editionBenefitsModalEntryPoint: EntryPoint<
	EditionBenefitsModalEntryPointComponent,
	EntryPointParams
> = createEntryPoint({
	root: JSResourceForInteraction<EditionBenefitsModalEntryPointComponent>(
		/* webpackChunkName: "@atlaskit-internal_edition-benefits-modal-relay" */ './edition-benefits-modal-relay',
		{
			moduleId: 'edition-benefits-modal-relay',
		},
	),
	getPreloadProps: ({ cloudId, product }: EntryPointParams) => ({
		queries: {
			editionBenefitsModalRelayQuery: {
				parameters: editionBenefitsModalRelayQueryParameters,
				variables: {
					cloudId,
					hamsProductKey: getHamsKey(product),
					projectType: getProjectType(product),
				},
			},
		},
		extraProps: {
			cloudId,
			product,
		},
	}),
});
